import React from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import {
  PLAY_TEST_OUTCOME_VALUE_CLEAR,
  formatPlayTestBooleanValue,
} from "@seabrookstudios/pitch2table-core";
import { SmartTextField } from "../core/SmartTextField";

/**
 * @param {import("@seabrookstudios/pitch2table-core").PlayTestOutcomeValueInput} value
 * @returns {"yes"|"no"|"unknown"}
 */
const toBooleanSelection = (value) => {
  if (value === true) {
    return "yes";
  }
  if (value === false) {
    return "no";
  }
  return "unknown";
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").PlayTestOutcomeValueInput} props.value
 * @param {(value: import("@seabrookstudios/pitch2table-core").PlayTestOutcomeValueInput) => void} props.onChange
 * @param {"small"|"medium"} [props.size]
 */
export const BooleanOutcomeSelect = ({ value, onChange, size = "small" }) => {
  /**
   * @param {*} _ev
   * @param {"yes"|"no"|"unknown"|null} next
   */
  const onChangeHandler = (_ev, next) => {
    if (next === null) {
      return;
    }
    if (next === "yes") {
      onChange(true);
      return;
    }
    if (next === "no") {
      onChange(false);
      return;
    }
    onChange(PLAY_TEST_OUTCOME_VALUE_CLEAR);
  };

  return (
    <ToggleButtonGroup
      exclusive
      size={size}
      value={toBooleanSelection(value)}
      onChange={onChangeHandler}
      aria-label="Yes, no, or unknown"
    >
      <ToggleButton value="yes">Yes</ToggleButton>
      <ToggleButton value="no">No</ToggleButton>
      <ToggleButton value="unknown">Unknown</ToggleButton>
    </ToggleButtonGroup>
  );
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").PlayTestMetadataValueType|undefined} props.valueType
 * @param {import("@seabrookstudios/pitch2table-core").PlayTestOutcomeValueInput} props.value
 * @param {(value: import("@seabrookstudios/pitch2table-core").PlayTestOutcomeValueInput) => void} props.onChange
 * @param {"small"|"medium"} [props.size]
 */
export const OutcomeValueField = ({ valueType, value, onChange, size = "small" }) => {
  if (valueType === "BOOLEAN") {
    return <BooleanOutcomeSelect value={value} onChange={onChange} size={size} />;
  }

  return (
    <SmartTextField
      size={size}
      initialValue={value === undefined || value === null ? "" : `${value}`}
      onChange={(text) => onChange(text)}
      type="number"
      textAlign="right"
    />
  );
};

/**
 * @param {import("@seabrookstudios/pitch2table-core").PlayTestOutcomeValueInput} value
 * @param {import("@seabrookstudios/pitch2table-core").PlayTestMetadataValueType|undefined} valueType
 * @returns {string}
 */
export const formatOutcomeValueForDisplay = (value, valueType) => {
  if (valueType === "BOOLEAN") {
    return formatPlayTestBooleanValue(value === true || value === false ? value : undefined);
  }
  if (value === undefined || value === null || value === PLAY_TEST_OUTCOME_VALUE_CLEAR) {
    return "";
  }
  return `${value}`;
};
